<template>
  <div class="row" style="margin-top: 70px;">
    <div class="col-3"></div>
    <div class="col-6" style="text-align: center;">
      <img
        style="width: 100%"
        src="https://firebasestorage.googleapis.com/v0/b/car-appointment-fsqahl.appspot.com/o/roomadmin_pictures%2FHarmsAutomotiveGroup1.png?alt=media&token=a95768ba-22d5-4240-b665-722a88dd4f4d"
      />

      <h2 style="margin-top: 45px;">Welcome to {{currLoc}} {{'service'}} page</h2>
      <b-jumbotron>
        <!-- <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Open+Sans" /> -->

        <div class="google-btn" v-on:click="googleSignIn()">
          <div class="google-icon-wrapper">
            <img
              class="google-icon"
              src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
            />
          </div>
          <p class="btn-text">
            <b>Sign in with google</b>
          </p>
        </div>
      </b-jumbotron>
    </div>
  </div>
</template>

<script>
import firebase from "../../firebase";
export default {
  name: "TheLogin",
  props: {
    currLoc: String
    // currlocService: String
  },
  methods: {
    googleSignIn() {
      // var provider = new firebase.auth.GoogleAuthProvider();

      firebase
        .auth()
        .signInWithPopup(new firebase.auth.GoogleAuthProvider())

        .catch(function(error) {
          console.log("err", error);
        });
    }
    // logIn() {
    //   this.$emit("TheLogin::loginResult", { loginResult: true });
    // }
  }
};
</script>

<style scoped>
.jumbotron {
  padding: 2rem;
  padding-top: 1rem !important;
  background: transparent;
}
@import url(https://fonts.googleapis.com/css?family=Roboto:500);
.google-btn {
  width: 184px;
  height: 42px;
  background-color: #4285f4;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
  margin: 0 auto;
  cursor: pointer;
}
.google-btn .google-icon-wrapper {
  position: absolute;
  margin-top: 1px;
  margin-left: 1px;
  width: 40px;
  height: 40px;
  border-radius: 2px;
  background-color: #fff;
}
.google-btn .google-icon {
  position: absolute;
  margin-top: 11px;
  margin-left: -8px;
  width: 18px;
  height: 18px;
}
.google-btn .btn-text {
  float: right;
  margin: 11px 11px 0 0;
  color: #fff;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Roboto";
}
.google-btn:hover {
  box-shadow: 0 0 6px #4285f4;
}
.google-btn:active {
  background: #1669f2;
}
</style>